import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPaginatedOrganizationExpiredTcesUseCaseInterface } from 'domain/usecases';

export class RemoteGetPaginatedOrganizationExpiredTces
  implements GetPaginatedOrganizationExpiredTcesUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetPaginatedOrganizationExpiredTcesUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetPaginatedOrganizationExpiredTcesUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationExpiredTcesUseCaseInterface.Result> {
    const {
      organizationHashId,
      page,
      length,
      courseHashIds,
      groupHashIds,
      search,
      orderColumn,
      orderDirection,
    } = params;

    const requestUrl = `${this.url}/${organizationHashId}/expired-tce/${page}/${length}`;
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, {
        'courseHashIds[]': courseHashIds,
        'groupHashIds[]': groupHashIds,
        search,
        orderColumn,
        orderDirection,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
